<template>
	<div>
		<Header :sel='1' @changePhone="changePhone"></Header>
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
		  <!-- your content here --> 
		  <!--banner-->
		  <div class="banner_index">
		    <el-carousel class="el-carousel" :interval="5000" height="37vw" arrow="always">
		          <el-carousel-item v-for="item in bannerList" :key="item.id">
		            <img ref="bannerHeight" :src="item.url" style="width:100%;height: auto;"/>
		          </el-carousel-item>
				  
		        </el-carousel>
		  </div>
		  <!--banner--> 
		  
		  <!--关于我们-->
		  <div class="main1">
		    <div class="title3"> <strong>关于我们</strong> </div>
		    <div class="main_c">
		      <div class="about_index">
		        <div class="about_index_pic"> <img :src="companyData.image" /></div>
		        <div class="about_index_txt">
		          <p v-html="companyData.cmsArticleData?companyData.cmsArticleData.content:''"></p>
		          <p align="right"><a href="javascript:void(0);" @click="goMore('/about?id=1665618104755376128')">查看更多></a></p>
		        </div>
		      </div>
		    </div>
		  </div>
		  <!--关于我们--> 
		  
		  <!--新闻资讯-->
		  <div class="main2">
		    <div class="title3"> <strong>新闻资讯</strong> </div>
		    <div class="main_c">
		      <div class="news_index_l">
		        <div class="news_index_l_top"> <a href="javascript:void(0);" @click="goDetail(newList[0].id)"><img :src="newList[0]?newList[0].image:''" />
		          <p>{{newList[0]?newList[0].title:''}}</p>
		          </a> </div>
		        <div class="news_index_l_bottom"> <a href="javascript:void(0);" @click="goDetail(newList[1]?newList[1].id:'')"><img :src="newList[1]?newList[1].image:''" />
		          <p>{{newList[1]?newList[1].title:''}}</p>
		          </a> <a @click="goDetail(newList[2]?newList[2].id:'')" href="javascript:void(0);"><img :src="newList[2]?newList[2].image:''" />
		          <p>{{newList[2]?newList[2].title:''}}</p>
		          </a> </div>
		      </div>
		      <div class="news_index_r">
		        <ul class="news_index_list">
		          <li class="news_first actived"><a @click="goDetail(newList[3]?newList[3].id:'')" href="javascript:void(0);">{{newList[3]?newList[3].title:''}}</a></li>
				  <!-- 4条 -->
		          <li v-for="(item,index3) in 4"><a @click="goDetail(newList[index3+4]?newList[index3+4].id:'')" href="javascript:void(0);">{{newList[index3+4]?newList[index3+4].title:''}}</a></li>
		          <li class="news_first"><a @click="goDetail(newList[8]?newList[8].id:'')" href="javascript:void(0);">{{newList[8]?newList[8].title:''}}</a></li>
		          
				  <li v-for="(item,index1) in 4"><a @click="goDetail(newList[index1+9]?newList[index1+9].id:'')" href="javascript:void(0);">{{newList[index1+9]?newList[index1+9].title:''}}</a></li>
		          
		          <li class="news_first"><a @click="goDetail(newList1[0]?newList1[0].id:'')" href="javascript:void(0);">{{newList1[0]?newList1[0].title:''}}</a></li>
		          <li v-for="(item,index2) in 4"><a @click="goDetail(newList1[index2+4]?newList1[index2+4].id:'')" href="javascript:void(0);">{{newList1[index2+4]?newList1[index2+4].title:''}}</a></li>
		        </ul>
		      </div>
		       <div class="ad"><a href="javascript:void(0);" @click="goDetail(adData.id)"><img :src="adData.image" /></a></div>
		    </div>
		  </div>
		  <!--新闻资讯--> 
		  <!--流亭精品-->
		  <div class="main2">
		    <div class="title3"> <strong>流亭精品</strong> </div>
		    <div class="main_c">
		      <div class="jingpin_l">
		        <div class="jingpin_l_top">
		          <ul class="jingpin_list1">
		            <li v-for="item in infoList1" ><a href="javascript:void(0);" @click="goProDetail(item.id)"><img :src="item.imageHome"/><br/>
		              {{item.productName}}</a></li>
		          </ul>
		        </div>
		        <div class="jingpin_l_bottom">
		          <ul class="jingpin_list2">
		            <li v-for="item in infoList2"><a href="javascript:void(0);" @click="goProDetail(item.id)"><img :src="item.imageHome" /><br />
		              {{item.productName}}</a></li>
		            
		          </ul>
		        </div>
		      </div>
		     <div class="ad"><a href="javascript:void(0);" @click="goDetail(adData2.id)"><img :src="adData2.image" /></a></div>
		    </div>
		  </div>
		   <!--流亭精品--> 
		   <Footer></Footer>
		  </div>
		 
		  
		  <!--main--> 
		
	</div>
</template>

<script>
	import axios from 'axios';
	import * as XLSX from "xlsx";
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{bannerList,articleList,infoList,articleDetail} from '@/api/reqFetch.js'
	export default {

		name: '',
		layout: '',
		components: {
			Footer,
			Header
		},
		data() {
			return {
				 screenheight: '',
				aboutList:[{
					img:'',
					title:''
				}],
				
				selId: '1',
				list: [],
				newList:[],
				newList1:[],
				jicenglist:[],
				tabList:[],
				selName:'全部',
				selid:'0',
				talentList:[],
				companyList:[],
				tableData:[],
				indexData:0,
				pageNum:4,
				bannerList:[],
				infoList1:[],
				infoList2:[],
				infoList3:[],
				index:0,
				companyData:{},
				showPhone:false,
				adData:{},
				adData2:{}
			}
		},
		
		

		mounted() {
			 this.getBannerList()
			 this.getNewList()
			 this.getInfoList()
			 this.getCompanylist()
			 window.addEventListener('resize',()=>{
			 	this.screenheight=this.$refs.bannerHeight[0].height+'px'
			 	this.imgLoad()			 
			 },false)
			
			
			 
		},

		methods: {
			changePhone(val){
				this.showPhone=val
			},
			imgLoad(){
				this.$nextTick(()=>{
					this.screenheight=this.$refs.bannerHeight[0].height+'px'
				})
			},
			goProDetail(id){
				this.$router.push({
					path:'/productDetail',
					query:{id:id}
				})
			},
			goMore(url) {
				this.$router.push(url)
			},
			goDetail(id) {
				this.$router.push({
					path: '/context',
					query: {
						id: id
					}
				})
			},
			
			
			getBannerList(){
				bannerList({}).then(res => {
				 this.bannerList=res.rows
				 this.imgLoad()
				});
			},
			changeTab(id,name){
				this.selName=name
				this.selid=id;
				this.init();
			},
			getNewList() {
				// 1001-公司新闻 1002-行业新闻 1003-其他
				articleList({
					pageNum: 1,
					pageSize: 20,
					categoryCode:'1001',
					orderNum:0
				}).then(res => {
					this.newList = res.rows;
					
				});
				articleList({
					pageNum: 1,
					pageSize: 20,
					categoryCode:'1002',
					orderNum:0
				}).then(res => {
					this.newList1 = res.rows;
					
				});
			},
			getInfoList() {
				infoList({
					pageNum: 1,
					pageSize: 10,
					categoryCode:'',
					orderNum:0
				}).then(res => {
					let aa=JSON.parse(JSON.stringify(res.rows))
					let bb=JSON.parse(JSON.stringify(res.rows))
					this.infoList1 = aa.splice(0,3);
					this.infoList2 = aa
					
				});
			},
			getCompanylist() {
				articleDetail({id:'1665924858784739328'}).then(res => {
				    this.companyData = res.data;
				});
				articleDetail({id:'1665928502340853760'}).then(res => {
				    this.adData = res.data;
				});
				articleDetail({id:'1665928576219324416'}).then(res => {
				    this.adData2 = res.data;
				});
				
			},
			pros_hover(id) {
				this.selId = id
			},
			goMore(url) {
				this.$router.push(url)
			},
			goDetail(id) {
				this.$router.push({
					path: '/context',
					query: {
						id: id
					}
				})
			},
			goqyDetail(id) {
				this.$router.push({
					path: '/context',
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	
	.el-carousel{
	    width: 100%
	}

</style>
